import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {SharedService} from "./shared.service";
import {AppUtilityService} from "./AppUtilityService";
import {Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";
@Injectable()
export class AddressBookService{
  constructor(private http: HttpClient, private sharedService: SharedService,private appUtil:AppUtilityService) {
  }
  jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      //console.error(error); // log error to console

      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }
  public getUserAddressBook(userId:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'addressbook/user/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUserAddressBook', {}))
    );
  }

  getUserAddressBookPaged(userId: string, page: number, size: number) {
  return this.http.get<any>(`${this.sharedService.getFranchiseUrl()}addressbook/user/${userId}/paged`, {
    params: { page: page - 1, size }   // ngb-pagination is 1-based, Spring is 0-based
  });
}
  public createAddressBook(addressBookCreate:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'addressbook/create',addressBookCreate, this.jsonOptions).pipe(
      catchError(this.handleError<any>('createAddressBook', {}))
    );
  }
  public deleteAddress(userId:any,addressId:any){
    return  this.http.delete(this.sharedService.getFranchiseUrl() + 'addressbook/user/'+userId+'/delete/'+addressId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteAddress', {}))
    );
  }
  public updateAddressBook(addressBook:any){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'addressbook/update',addressBook, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateAddressBook', {}))
    );
  }
  
  public downloadTemplate(){
    return  this.sharedService.getFranchiseUrl() + 'addressbook/download/template'
  }

  public uploadAddressBook(addressBookUpload:any, userId:any){
    return  this.http.post(`${this.sharedService.getFranchiseUrl()}addressbook/upload/address/book/user/${userId}`,addressBookUpload, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('uploadAddressBook', {}))
    );
  }

  public handleMapCallback(obj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'session/map-selector-callback',obj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('createAddressBook', {}))
    );
  }
  public getSelectedPudoPoint(guid:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'session/selected/pudo-point/'+guid, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getSelectedPudoPoint', {}))
    );
  }

  public findSuburbs(suburb:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'addressbook/postal/code/'+suburb, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getSelectedPudoPoint', {}))
    );
  }

   public updateDefaultAddressBook(addressBook:any){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'addressbook/create/default',addressBook, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateDefaultAddressBook', {}))
    );
  }

   public getUserDefaultAddressBook(userId:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'addressbook/user/'+userId+'/default', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUserDefaultAddressBook', {}))
    );
  }


 

   

}
